import {Page, type PageProps} from '@hconnect/uikit/src/lib2/pageContainer'
import {mergeSx} from '@hconnect/uikit/src/lib2/utils'
import React from 'react'

type StockPageLayoutProps = Partial<
  Pick<
    PageProps,
    | 'title'
    | 'headerActionContent'
    | 'nameHeaderSx'
    | 'nameBodySx'
    | 'sxActionContent'
    | 'aboveTitle'
    | 'sx'
    | 'py'
    | 'data-test-id'
  >
> & {
  children: React.ReactNode
}

/**
 * Wrapper around the uikit page component that takes care of some default props for planner specifically.
 * @param classNameHeader
 * @param children
 * @param props
 * @constructor
 */
export const StockPageLayout = ({
  nameHeaderSx,
  children,
  py = 6,
  ...props
}: StockPageLayoutProps) => {
  return (
    <Page
      sx={{
        px: {
          xs: 2,
          lg: 6
        }
      }}
      boxed={false}
      nameHeaderSx={mergeSx({mb: 1.5, px: 3}, nameHeaderSx)}
      py={py}
      {...props}
    >
      {children}
    </Page>
  )
}
StockPageLayout.displayName = 'StockPageLayout'
